import React, {useRef, useState, Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";

import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import SvgIcon from "@mui/material/SvgIcon";
import InfoIcon from "@mui/icons-material/Info";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Paper from '@mui/material/Paper';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

// import IconButton from "@mui/material/IconButton";

import {setLookContextMenu, setLookOpened} from "../../../actions/lookFunctions";
import BathroomFeatureGroupsIcons from "../../common/svgIcons/bathroomFeatureGroupIcons";

import {
  CONTEXT_MENU_BATHTUB_BUTTONS,
  CONTEXT_MENU_VANITY_BUTTONS,
  CONTEXT_MENU_VANITY_ONLY,
  VANITY_TYPES,
  CONTEXT_MENU_SHOWER_ALL,
  CONTEXT_MENU_SHOWER_OTHER,
  LOOK_ROOM_TYPES,
  CONTEXT_MENU_KITCHEN_COUNTERTOPS,
  CONTEXT_MENU_KITCHEN_CENTER_ISLAND
} from "../core/constants";
import {getCurrentLayout, getCurrentRoomType} from "../../appLayout";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {checkForContextMenuCommon} from "./lookFunctions";
import LookContextMenuVanityContent from "./lookContextMenuVanityContent";
import Button from "@mui/material/Button";
import WithUpdateLookCartItem from "../hocs/withUpdateLookCartItem";
import {setWizardActiveItem} from "../../../actions/wizardFunctions";
import {getLookIdUrl} from "./lookFunctions2";
import {ROUTES} from "../../../routes";
import {getCommonVisualizerType, IS_PRODUCT_JOURNEY} from "../../../config";
import {checkIfLookFeaturesReceived} from "../../../api/look-api";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";

const needToRequestFeatureGroupsOnClick = ["vanity_washstand", "vanity_console", "shower_arm", "shower_head"];

const LookContextMenuContent = (props) => {

  const {contextMenu, setLookContextMenu, zoomToFeatureGroup, intl, isMobile, wizardList, setWizardActiveItem, history,
    setLookOpened, fabricatorData} = props;

  const {partId, layerPosition} = contextMenu;
  const anchorRef = useRef(null);
  const [vanitySubMenuOpened, setVanitySubMenuOpened] = useState(false);
  const layout = getCurrentLayout();

  const {allButtons, showButtons} = checkForContextMenuCommon(partId, layerPosition);
  const activeVanityType = layout.parts["Vanity"] && layout.parts["Vanity"].vanity_type ? layout.parts["Vanity"].vanity_type : VANITY_TYPES.vanity_cabinet;
  const isBathroom = getCommonVisualizerType() === "bathroom";
  const isVanity = isBathroom && CONTEXT_MENU_VANITY_BUTTONS.includes(partId);
  const isShower = isBathroom && (CONTEXT_MENU_SHOWER_ALL.includes(partId) || CONTEXT_MENU_SHOWER_OTHER.includes(partId));
  const isCenterIsland = !isBathroom && CONTEXT_MENU_KITCHEN_CENTER_ISLAND.includes(partId);

  const contextButtonClick = async (currentPartId, updateLookCartItem) => {
    // console.log("currentPartId", currentPartId);
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productCanvasContextMenuItem + currentPartId
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookCanvasContextMenuItem + currentPartId
    Analytics.sendClickEvent(analyticsLabel);

    if (isVanity && !vanitySubMenuOpened && CONTEXT_MENU_VANITY_ONLY.includes(currentPartId)) {
      setVanitySubMenuOpened(true);
      return false
    } else if (vanitySubMenuOpened) {
      setVanitySubMenuOpened(false);
    }

    setLookContextMenu({
      opened: false,
      layerPosition: "",
      clickedOnItem: currentPartId,
    });

    let openPartId = currentPartId;
    let clickedFeature = null;

    if (isVanity && (getCurrentRoomType(layout) === LOOK_ROOM_TYPES.as) && (currentPartId === "vanity_pedestal_sink" || currentPartId === "vanity_sink")) {
      openPartId = "vanity_sink";
      const sinkParent = layout.getFeatureGroupByPartId(openPartId);
      if (sinkParent) {
        const navItems = layout.designNavigationItems({part: sinkParent}, null, null, sinkParent.activeFeature);
        if (currentPartId === "vanity_pedestal_sink") {
          const pedestalSink = navItems.find(navItem => {
            return navItem.part.metaData["MountType"] && navItem.part.metaData["MountType"].includes("ST")
          });
          if (pedestalSink) {
            clickedFeature = pedestalSink.part;
          }
        } else {
          const isPedestal = sinkParent.activeFeature && sinkParent.activeFeature.metaData["MountType"] && sinkParent.activeFeature.metaData["MountType"].includes("ST");
          if (isPedestal) {
            const regularSink = navItems.find(navItem => {
              return !navItem.part.metaData["MountType"] || !navItem.part.metaData["MountType"].includes("ST")
            });
            if (regularSink) {
              clickedFeature = regularSink.part;
            }
          }
        }
      }
    }

    if (openPartId.includes("_wizard")) {
      const wizardId = openPartId.split("-")[1];
      setLookOpened(true);
      setWizardActiveItem(wizardList.find(wizardItem => wizardItem.id === wizardId));

      history.push(`${getLookIdUrl(false) + ROUTES.wizard}/${wizardId}`);
      return false
    }

    const featureGroup = layout.getFeatureGroupByPartId(openPartId);
    if (featureGroup && !featureGroup.allFeaturesReceived && needToRequestFeatureGroupsOnClick.includes(openPartId)) {
      loaderEnable();
      await checkIfLookFeaturesReceived(featureGroup);
      loaderDisable();
    }

    const clickOnFeature = !openPartId.includes("edge");
    const zoomedFeature = zoomToFeatureGroup(openPartId, clickedFeature, layerPosition, true, !(!IS_PRODUCT_JOURNEY && isMobile), true, clickOnFeature);
    updateLookCartItem(clickedFeature || zoomedFeature);
  };

  if (isShower && showButtons.length > 5) {
    return (
      <WithUpdateLookCartItem>
        {(updateLookCartItem) => (
          <div id="context-menu" className="look-context__buttons">
            {showButtons.map(button => {
              const currentPartId = button.partId;
              const isParentButton = false;
              const isShowerWizard = currentPartId.includes("shower_wizard");
              const buttonText = intl.formatMessage({id: isParentButton
                  ? "visualizer.bathroom.vanity.furniture"
                  : "visualizer.bathroom.shower." + (isShowerWizard ? "shower" : currentPartId)})
              const startIcon = isShowerWizard
                ? <AutoFixHighIcon/>
                : isParentButton
                  ? <ChevronRightIcon />
                  : BathroomFeatureGroupsIcons[currentPartId]
                    ? <SvgIcon>{BathroomFeatureGroupsIcons[currentPartId]}</SvgIcon>
                    : <InfoIcon/>;
              return (
                <Button key={currentPartId}
                        ref={isParentButton ? anchorRef : null}
                        className="look-button look-button--white look-button--base-radius look-context__buttons-button"
                        onClick={() => contextButtonClick(currentPartId, updateLookCartItem)}
                        startIcon={startIcon}>
              <span className="look-context__buttons-button-text">
                {isShowerWizard ? <Fragment><FormattedMessage id="wizard.contextMenu.wizardBuild"/> </Fragment> : null}{buttonText}
              </span>
                </Button>
              )
            })}
          </div>
        )}
      </WithUpdateLookCartItem>
    )
  }

  return (
    <Paper id="context-menu">
      <WithUpdateLookCartItem>
        {(updateLookCartItem) => (
          <MenuList>
            {showButtons.map(button => {
              const currentPartId = button.partId;
              const isVanityParent = isVanity && CONTEXT_MENU_VANITY_ONLY.includes(currentPartId);
              const isVanityWizard = currentPartId.includes("vanity_wizard");
              const isShowerWizard = currentPartId.includes("shower_wizard");
              const isCenterIslandWizard = isCenterIsland && currentPartId.includes("counterop_wizard");
              const isWizard = isVanityWizard || isShowerWizard || isCenterIslandWizard;

              let wizButtonName = isVanityWizard
                ? wizardList.find(wizItem => wizItem.id === +currentPartId.split("vanity_wizard-")[1]).name
                : isCenterIslandWizard
                  ? wizardList.find(wizItem => wizItem.id === +currentPartId.split("counterop_wizard-")[1]).name
                  : "";
              let buttonTextId = "";

              if (isBathroom) {

                let translate = "";
                if (CONTEXT_MENU_BATHTUB_BUTTONS.includes(currentPartId)) {
                  translate = "bathtub"
                } else if (isVanity || isVanityWizard) {
                  translate = "vanity"
                } else if (currentPartId === "split_wall") {
                  translate = "walls"
                } else {
                  translate = "shower"
                }

                buttonTextId = isVanityParent
                  ? "visualizer.bathroom.vanity.furniture"
                  : "visualizer.bathroom."+translate+"." + (isVanityWizard
                  ? activeVanityType === "vanity_cabinet" ? "vanity" : activeVanityType
                  : isShowerWizard ? "shower" : currentPartId)
              } else {
                buttonTextId = CONTEXT_MENU_KITCHEN_COUNTERTOPS.includes(currentPartId)
                  ? "visualizer.kitchen.countertop." + currentPartId
                  : "visualizer.kitchen.center_island." + currentPartId
              }

              return (
                <MenuItem key={currentPartId}
                          ref={isVanityParent ? anchorRef : null}
                          className="look-sidebar__modal-item"
                          onClick={() => contextButtonClick(currentPartId, updateLookCartItem)}>
                  <ListItemIcon>
                    {isWizard
                      ? <AutoFixHighIcon/>
                      : BathroomFeatureGroupsIcons[currentPartId]
                        ? <SvgIcon>{BathroomFeatureGroupsIcons[currentPartId]}</SvgIcon>
                        : <InfoIcon/>}
                  </ListItemIcon>
                  {isWizard && (fabricatorData.isLixil || isCenterIslandWizard)
                    ? <FormattedMessage id={fabricatorData.isLixil ? "wizard.contextMenu.wizardDesignMy" : "wizard.contextMenu.wizardBuild"}/>
                    : null}
                  {isWizard && (fabricatorData.isLixil || isCenterIslandWizard) ? " " : null}
                  {!fabricatorData.isLixil && wizButtonName ? wizButtonName : (
                    <FormattedMessage id={buttonTextId}/>
                  )}
                  {isVanityParent && !isVanityWizard ? <div className="look-sidebar__modal-item-secondary"><ChevronRightIcon /></div> : null}
                </MenuItem>
              )
            })}
            {isVanity ? <LookContextMenuVanityContent contextButtonClick={contextButtonClick}
                                                      anchorEl={anchorRef}
                                                      buttons={allButtons.filter(button => CONTEXT_MENU_VANITY_ONLY.includes(button.partId))}
                                                      vanitySubMenuOpened={vanitySubMenuOpened}/> : null}
          </MenuList>
        )}
      </WithUpdateLookCartItem>
    </Paper>
  )
};

LookContextMenuContent.propTypes = {
  zoomToFeatureGroup: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {contextMenu} = store.lookState;
  const {isMobile} = store.serverState;
  const {wizardList} = store.wizardState;
  const fabricatorData = store.fabricatorState;

  return {
    contextMenu,
    isMobile,
    wizardList,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookContextMenu,
  setLookOpened,
  setWizardActiveItem,
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(LookContextMenuContent)
  )
)
